import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative z-1 mx-auto my-12 flex max-w-[1286px] flex-col-reverse overflow-hidden rounded-[20px] bg-white max-lg:mx-3 lg:my-20 lg:flex-row lg:items-center lg:justify-end lg:rounded-[40px] lg:[background:linear-gradient(72.7deg,#FFFFFF_-7.25%,#F7F7F7_36.66%)]',
    title:
      'text-brand-bioderma mb-1 text-2xl leading-[1.1] font-medium uppercase lg:mb-2 lg:text-4xl',
    text: 'text-brand-bioderma mb-5 text-lg lg:mb-7 lg:text-2xl',
    content:
      'z-2 max-lg:pt-6 max-lg:pr-2 max-lg:pb-8 max-lg:pl-5 lg:absolute lg:top-1/2 lg:left-30 lg:max-w-150 lg:-translate-y-1/2',
    image: 'w-full lg:relative lg:-right-[1px]',
    visual: 'lg:w-[55.3%]',
    button:
      'bg-brand-bioderma flex-center border-brand-bioderma hover:text-brand-bioderma Lg:w-[253px] mt-2 flex h-[48px] w-[253px] cursor-pointer border pt-[2px] text-base leading-[1] font-medium text-white transition-colors duration-300 hover:bg-white lg:mt-[18px]',
    brDesktop: 'hidden lg:block'
  }
});
